document.addEventListener("DOMContentLoaded", function() {
  var quant;
  var min = parseInt(1, 10);

  document.addEventListener("pointerdown", function(event) {
    if (event.target.matches('[data-type="plus"]')) {
      var inputElement = event.target.parentElement.querySelector('input[type="number"]');
      quant = parseInt(inputElement.value, 10);
      quant++;
      inputElement.value = quant;
    }

    if (event.target.matches('[data-type="minus"]')) {
      var inputElement = event.target.parentElement.querySelector('input[type="number"]');
      quant = parseInt(inputElement.value, 10);
      if (quant > min) {
        quant--;
        inputElement.value = quant;
      }
    }
  });
});
